module.exports = __webpack_public_path__ + "media/images/flags/32/Saint-Vincent-and-the-Grenadines-a9f043cc4948140a978ab7afa8afb115.png";